import { faker } from '@faker-js/faker'
import { Factory } from 'miragejs'

export default Factory.extend({
  externalId() {
    return faker.number.int()
  },
  firstName() {
    return faker.person.firstName()
  },
  lastName() {
    return faker.person.lastName()
  },
  gradePosition() {
    return faker.number.int({
      min: 1,
      max: 6,
    })
  },
  login() {
    return faker.internet.username()
  },
  plainPassword() {
    return faker.internet.password()
  },
})
